import { render, staticRenderFns } from "./SandboxInstructionsPanel.vue?vue&type=template&id=9098867e&"
import script from "./SandboxInstructionsPanel.vue?vue&type=script&lang=js&"
export * from "./SandboxInstructionsPanel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/cjzhi98/chatwoot-saas/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('9098867e')) {
      api.createRecord('9098867e', component.options)
    } else {
      api.reload('9098867e', component.options)
    }
    module.hot.accept("./SandboxInstructionsPanel.vue?vue&type=template&id=9098867e&", function () {
      api.rerender('9098867e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/javascript/dashboard/routes/dashboard/onboardingShell/steps/sandbox/SandboxInstructionsPanel.vue"
export default component.exports